import PageHeader from "../../components/PageHeader";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import ButtonFilled from "../../components/FormElements/ButtonFilled";
import {Link, useHistory} from "react-router-dom";
import branchApi from "../../store/branchStore/branchApi";
import {useSelector} from "react-redux";
import Loader from "../../components/Loader";

const statusStyle = {
  fontFamily: 'sf, serif',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '11px',
  lineHeight: '13px',
  textAlign: 'center',
  letterSpacing: '0.2px',
  color: '#FFFFFF',
  borderRadius: '3px',
  whiteSpace: 'nowrap'
}

const loaderStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.3)', // rgba(#fff, .3) converted to rgba(255,255,255,0.3)
  zIndex: 99,
};

const editIcon = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M18.8571 14.28V18.8571C18.8571 19.3118 18.6765 19.7478 18.355 20.0693C18.0335 20.3908 17.5975 20.5714 17.1428 20.5714H5.14284C4.68819 20.5714 4.25215 20.3908 3.93066 20.0693C3.60917 19.7478 3.42856 19.3118 3.42856 18.8571V6.85713C3.42856 6.40247 3.60917 5.96644 3.93066 5.64495C4.25215 5.32346 4.68819 5.14284 5.14284 5.14284H9.71999M17.1428 3.42856L20.5714 6.85713L12 15.4286H8.57142V12L17.1428 3.42856Z"
      stroke="#4EB78B" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)
const trashIcon = (
  <svg width="20" height="20" viewBox="0 0 13 16" fill="currentColor">
    <path d="M8.4375 2.375H11.25C11.8125 2.375 12.1875 2.75 12.1875 3.3125V4.25H0V3.3125C0 2.75 0.46875 2.375 0.9375 2.375H3.75C3.9375 1.34375 4.96875 0.5 6.09375 0.5C7.21875 0.5 8.25 1.34375 8.4375 2.375ZM4.6875 2.375H7.5C7.3125 1.8125 6.65625 1.4375 6.09375 1.4375C5.53125 1.4375 4.875 1.8125 4.6875 2.375ZM0.9375 5.1875H11.25L10.4062 14.6562C10.4062 15.125 9.9375 15.5 9.46875 15.5H2.71875C2.25 15.5 1.875 15.125 1.78125 14.6562L0.9375 5.1875Z" fill="currentColor"/>
  </svg>
)

const List = () => {
  const { t } = useTranslation()
  const {info} = useSelector(s => s.branchReducer)
  const [loading, setLoading] = useState(false)
  const [certificates, setCertificates] = useState([])
  const [deletingCertificate, setDeletingCertificate] = useState('')
  const history = useHistory();

  const getCertificates = async () => {
    if (!info?.id) return
    try {
      setLoading(true)
      const certificatesData = await branchApi.getBranchCertificates(info?.id)
      setCertificates(certificatesData.data)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getCertificates()
  }, [info?.id])

  const renderStatus = (order) => {
    if (order.status === 'active') {
      return <span
        style={{
          ...statusStyle,
            background: '#24CC64', padding: "8px 19px"
        }}
      >
        {t('active')}
      </span>
    }

    return <span style={{...statusStyle, background: '#FA6262', padding: "8px 12px"}}>{t('disabled')}</span>
  }

  const handleDeleteCertificate = async (certificateId) => {
    setDeletingCertificate(certificateId)
    try {
      await branchApi.deleteBranchCertificate(info.id, certificateId)
      getCertificates()
    } finally {
      setDeletingCertificate('')
    }
  }

  return (
    <>
      <PageHeader title={t('certificate')}>
        <Link to="/profile/certificate/form" style={{ marginLeft: 'auto', textDecoration: 'none' }}>
          <ButtonFilled>
            {t("Certificate.create")}
          </ButtonFilled>
        </Link>
      </PageHeader>

      <div style={{position: 'relative'}}>
        {loading && (
          <div style={loaderStyle}>
            <Loader color="#000" style={{zIndex: 100, opacity: 1}}/>
          </div>
        )}
        <table className="table">
          <thead>
          <tr>
            <th>{t('period')}</th>
            <th>{t('header')}</th>
            <th>{t('NSCumulative.amount')}</th>
            <th>{t('NSGeneral.clients')}</th>
            <th>{t('status')}</th>
            <th>{t('action')}</th>
          </tr>
          </thead>
          <tbody>
          {certificates.map((certificate, index) => (
            <tr
              onClick={(e) => history.push(`/profile/certificate/${certificate.id}`)}
              key={certificate.id}
            >
              <td>
                {certificate.expiration_days} {t('NSPlural.days')}
              </td>
              <td>
                {certificate.header}
              </td>
              <td>
                {certificate.bonus_amount}
              </td>
              <td>
                {certificate.client_amount}
              </td>
              <td>
                {renderStatus(certificate)}
              </td>
              <td
                style={{ maxWidth: '45px' }}
                onClick={(e) => e.stopPropagation()}
              >
                <div style={{ display: 'flex', gap: 4, justifyContent: 'flex-end' }}>
                  <button
                    type="button"
                    onClick={() => handleDeleteCertificate(certificate.id)}
                    style={{
                      border: 'none',
                      cursor: 'pointer',
                      color: 'tomato',
                      background: 'transparent',
                      position: 'relative'
                    }}
                  >
                    {deletingCertificate === certificate.id ? <Loader color="#000" style={{ zIndex: 100, opacity: 1, transform: 'scale(0.8)' }}/> : trashIcon}
                  </button>
                  {/*<button*/}
                  {/*  type="button"*/}
                  {/*  style={{*/}
                  {/*    border: 'none',*/}
                  {/*    cursor: 'pointer',*/}
                  {/*    background: 'transparent',*/}
                  {/*    fontSize: '14px',*/}
                  {/*    position: 'relative'*/}
                  {/*  }}*/}
                  {/*>*/}
                  {/*  {editIcon}*/}
                  {/*</button>*/}
                </div>
              </td>
            </tr>
          ))}
          {!certificates.length && (
            <tr>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
              <td>-</td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
    </>
  )
}

export default List;